import { NgModule } from '@angular/core';
import { AdminComponent } from './admin.component';
import { CommonModule } from '@angular/common';
import { AdminRoutingModule } from './admin.routing';
import { AdminGuard } from './services/admin.guard';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { GridModule } from '@progress/kendo-angular-grid';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { TopPanelComponent } from './top-panel/top-panel.component';
import { BottomPanelComponent } from './bottom-panel/bottom-panel.component';

@NgModule({
  declarations: [AdminComponent, TopPanelComponent, BottomPanelComponent],
  imports: [
    CommonModule,
    AdminRoutingModule,
    ExcelExportModule,
    NgxChartsModule,
    ButtonModule,
    GridModule,
    NgxDatatableModule
  ],
  providers: [AdminGuard]
})
export class AdminModule {}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/admin/admin.module.ts